;
define("menu_tree.tpl", function(){});

